import stringify from 'utils/stringify';

const mapErrorToMessage = (error: ErrorEvent | unknown): string => {
  return (error as ErrorEvent)?.message || stringify(error) || 'No Error or Message has been provided';
};

export default mapErrorToMessage;
